module.exports = __webpack_public_path__ + "img/genre07.8fbbc689.jpg";